class BundleCard {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // Add to cart button functionality
    const addToCartButtons = document.querySelectorAll('.bundle-card__btn--primary');
    
    addToCartButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToCart(button);
      });
    });
  }

  async addToCart(button) {
    const productId = button.dataset.productId;
    const variantId = button.dataset.variantId;
    
    if (!productId || !variantId) {
      console.error('Product ID or Variant ID not found');
      this.showMessage('Error: Product not found', 'error');
      return;
    }

    // Show loading state
    const originalText = button.textContent;
    button.textContent = 'Adding...';
    button.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (response.ok) {
        const data = await response.json();
        this.showMessage('Bundle added to cart!', 'success');
        this.updateCartCount();
        
        // Optional: Open cart drawer if it exists
        this.openCartDrawer();
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to add to cart');
      }
    } catch (error) {
      console.error('Add to cart error:', error);
      this.showMessage('Failed to add bundle to cart', 'error');
    } finally {
      // Reset button state
      button.textContent = originalText;
      button.disabled = false;
    }
  }

  showMessage(message, type = 'info') {
    // Create message element
    const messageEl = document.createElement('div');
    messageEl.className = `bundle-card__message bundle-card__message--${type}`;
    messageEl.textContent = message;
    
    // Style the message
    Object.assign(messageEl.style, {
      position: 'fixed',
      top: '20px',
      right: '20px',
      padding: '12px 20px',
      borderRadius: '6px',
      color: '#fff',
      fontWeight: '600',
      zIndex: '9999',
      opacity: '0',
      transform: 'translateY(-20px)',
      transition: 'all 0.3s ease'
    });

    // Set background color based on type
    switch (type) {
      case 'success':
        messageEl.style.backgroundColor = '#28a745';
        break;
      case 'error':
        messageEl.style.backgroundColor = '#dc3545';
        break;
      default:
        messageEl.style.backgroundColor = '#007bff';
    }

    // Add to page
    document.body.appendChild(messageEl);

    // Animate in
    requestAnimationFrame(() => {
      messageEl.style.opacity = '1';
      messageEl.style.transform = 'translateY(0)';
    });

    // Remove after 3 seconds
    setTimeout(() => {
      messageEl.style.opacity = '0';
      messageEl.style.transform = 'translateY(-20px)';
      setTimeout(() => {
        if (messageEl.parentNode) {
          messageEl.parentNode.removeChild(messageEl);
        }
      }, 300);
    }, 3000);
  }

  updateCartCount() {
    // Update cart count in header if it exists
    const cartCountEl = document.querySelector('.thb-item-count, .cart-count, [data-cart-count]');
    if (cartCountEl) {
      // Fetch current cart count
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          cartCountEl.textContent = cart.item_count;
        })
        .catch(error => {
          console.error('Failed to update cart count:', error);
        });
    }
  }

  openCartDrawer() {
    // Try to open cart drawer if it exists
    const cartDrawer = document.querySelector('.cart-drawer, .side-panel[data-side-panel="cart"]');
    if (cartDrawer) {
      // Trigger cart drawer open event or method
      const openEvent = new CustomEvent('cart:open');
      document.dispatchEvent(openEvent);
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new BundleCard();
});

// Also initialize if script is loaded after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new BundleCard();
  });
} else {
  new BundleCard();
}
